import { useState, useEffect } from 'react';
import { NeedsList } from '../../../types/needs';
import { mockNeedsLists } from '../../../data/mockNeedsData';

export const useNeedsData = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<NeedsList[]>([]);

  useEffect(() => {
    const t = setTimeout(() => {
      setData(mockNeedsLists);
      setIsLoading(false);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  return { data, isLoading };
};
